export const Coefficients = {
  minute: 60 * 1000,
  hour: 3600 * 1000,
  day: 24 * 3600 * 1000,
};

export const TagColors = [
  {
    mainColor: "#EEA956",
    secondColor: "#EEA95660",
  },
  {
    mainColor: "#FF8F67",
    secondColor: "#FF8F6760",
  },
  {
    mainColor: "#5D95E8",
    secondColor: "#5D95E860",
  },
  {
    mainColor: "#EA942C",
    secondColor: "#EA942C60",
  },
  {
    mainColor: "#3ED6A4",
    secondColor: "#3ED6A460",
  },
  {
    mainColor: "#848DF9",
    secondColor: "#848DF960",
  },
  {
    mainColor: "#A123F9",
    secondColor: "#A123F960",
  },
  {
    mainColor: "#F923D1",
    secondColor: "#F923D160",
  },
  {
    mainColor: "#23F9F2",
    secondColor: "#23F9F260",
  },
  {
    mainColor: "#F9C123",
    secondColor: "#F9C12360",
  },
];

export const privateRoutes = ["create-project","profile","notifications","create-result","create-profile"]